import Icon from "@ant-design/icons";

const KeyControlKIconSVG = (props) => (
  <svg
    width="51"
    height="24"
    viewBox="0 0 51 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="50" height="23" rx="3.5" stroke="#9A8EA4" />
    <path
      d="M20.6663 15.1667H15.333C15.0597 15.1667 14.833 14.94 14.833 14.6667V9.33337C14.833 9.06004 15.0597 8.83337 15.333 8.83337H20.6663C20.9397 8.83337 21.1663 9.06004 21.1663 9.33337V14.6667C21.1663 14.94 20.9397 15.1667 20.6663 15.1667ZM15.833 14.1667H20.1663V9.83337H15.833V14.1667Z"
      fill="#9A8EA4"
    />
    <path
      d="M13.3335 19.1666C11.9535 19.1666 10.8335 18.0466 10.8335 16.6666C10.8335 15.2866 11.9535 14.1666 13.3335 14.1666H15.3335C15.6068 14.1666 15.8335 14.3933 15.8335 14.6666V16.6666C15.8335 18.0466 14.7135 19.1666 13.3335 19.1666ZM13.3335 15.1666C12.5068 15.1666 11.8335 15.84 11.8335 16.6666C11.8335 17.4933 12.5068 18.1666 13.3335 18.1666C14.1602 18.1666 14.8335 17.4933 14.8335 16.6666V15.1666H13.3335Z"
      fill="#9A8EA4"
    />
    <path
      d="M15.3335 9.83325H13.3335C11.9535 9.83325 10.8335 8.71325 10.8335 7.33325C10.8335 5.95325 11.9535 4.83325 13.3335 4.83325C14.7135 4.83325 15.8335 5.95325 15.8335 7.33325V9.33325C15.8335 9.60659 15.6068 9.83325 15.3335 9.83325ZM13.3335 5.83325C12.5068 5.83325 11.8335 6.50659 11.8335 7.33325C11.8335 8.15992 12.5068 8.83325 13.3335 8.83325H14.8335V7.33325C14.8335 6.50659 14.1602 5.83325 13.3335 5.83325Z"
      fill="#9A8EA4"
    />
    <path
      d="M22.667 9.83325H20.667C20.3937 9.83325 20.167 9.60659 20.167 9.33325V7.33325C20.167 5.95325 21.287 4.83325 22.667 4.83325C24.047 4.83325 25.167 5.95325 25.167 7.33325C25.167 8.71325 24.047 9.83325 22.667 9.83325ZM21.167 8.83325H22.667C23.4937 8.83325 24.167 8.15992 24.167 7.33325C24.167 6.50659 23.4937 5.83325 22.667 5.83325C21.8403 5.83325 21.167 6.50659 21.167 7.33325V8.83325Z"
      fill="#9A8EA4"
    />
    <path
      d="M22.667 19.1666C21.287 19.1666 20.167 18.0466 20.167 16.6666V14.6666C20.167 14.3933 20.3937 14.1666 20.667 14.1666H22.667C24.047 14.1666 25.167 15.2866 25.167 16.6666C25.167 18.0466 24.047 19.1666 22.667 19.1666ZM21.167 15.1666V16.6666C21.167 17.4933 21.8403 18.1666 22.667 18.1666C23.4937 18.1666 24.167 17.4933 24.167 16.6666C24.167 15.84 23.4937 15.1666 22.667 15.1666H21.167Z"
      fill="#9A8EA4"
    />
    <path
      d="M40.64 16H38.92L37.05 12.99L36.41 13.45V16H34.9V8.86H36.41V12.13C36.51 11.99 36.61 11.85 36.71 11.71C36.81 11.57 36.91 11.43 37.01 11.29L38.94 8.86H40.62L38.13 12.02L40.64 16Z"
      fill="#9A8EA4"
    />
  </svg>
);
const KeyControlKIcon = (props) => (
  <Icon component={KeyControlKIconSVG} {...props} />
);

export default KeyControlKIcon;
